import React from 'react';
import {
  CheckboxList,
  CheckboxListProps,
} from '@legacy-vfuk/core-checkbox-list';
import {
  ContentfulFilters,
  TagSubtopic,
} from './types/SectionFilterableArticles.types';

type DrawerChecboxList = {
  label: string;
  tempFilterList: ContentfulFilters;
  tempFilterSubfilterList?: ContentfulFilters;
  filters: ContentfulFilters;
  updateFilterList: (slugName: string) => void;
  updateSubfilterList?: (slugname: string, parentSlugname: string) => void;
};

const DrawerCheckboxList = ({
  tempFilterList,
  tempFilterSubfilterList,
  label,
  filters,
  updateFilterList,
  updateSubfilterList,
}: DrawerChecboxList) => {
  const chekcboxStates = filters.map(filter =>
    tempFilterList.some(f => f.slugName === filter.slugName)
  );
  const subtopicCheckboxStates = createSubfilterStates('subtopics');

  function createSubfilterStates(subfilterType: string) {
    const filterSubStates: {
      parentSlug: string;
      subfilterStates: boolean[];
    }[] = [];
    if (subfilterType === 'subtopics') {
      filters.forEach(filter => {
        if ('subtopics' in filter && filter.subtopics) {
          filterSubStates.push({
            parentSlug: filter.slugName,
            subfilterStates: filter.subtopics.map(subtopic =>
              tempFilterSubfilterList
                ? tempFilterSubfilterList.some(
                    f => f.slugName === subtopic.slugName
                  )
                : false
            ),
          });
        }
      });
    }
    return filterSubStates;
  }

  const getSubfilterCheckedStatus = (slugName: string, index: number) => {
    const foundCheckboxStates = subtopicCheckboxStates.find(subfilterState => {
      return subfilterState.parentSlug === slugName;
    });
    if (foundCheckboxStates) {
      return foundCheckboxStates.subfilterStates[index];
    }
  };

  const checkboxItems: CheckboxListProps['checkboxes']['items'] = filters.map(
    (filter, idx) => {
      if ('subtopics' in filter && filter.subtopics) {
        return {
          label: filter.displayName,
          value: filter.slugName,
          checked: chekcboxStates[idx],
          checkboxes: {
            items: filter.subtopics.map((subtopic: TagSubtopic, idx) => ({
              label: subtopic.displayName,
              value: subtopic.slugName,
              checked: getSubfilterCheckedStatus(filter.slugName, idx),
            })),
            onChange: e => {
              updateSubfilterList &&
                updateSubfilterList(e.target.value, filter.slugName);
            },
          },
        };
      } else {
        return {
          label: filter.displayName,
          value: filter.slugName,
          checked: chekcboxStates[idx],
        };
      }
    }
  );

  const checkboxes: CheckboxListProps['checkboxes'] = {
    id: label,
    groupName: label,
    items: checkboxItems,
    onChange: e => {
      updateFilterList(e.target.value);
    },
  };

  return (
    <CheckboxList
      checkboxes={checkboxes}
      fieldWrapper={{
        label: label,
        showLabel: false,
      }}
    />
  );
};

export default DrawerCheckboxList;
